import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  user: null,
  isLogin: localStorage.getItem("GuideproAI_user") ? true : false,
  isLoading: false,
};

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUserData: (state, action) => {
      state.isLogin = action?.payload?.token ? true : false;
    },
    setUser: (state, action) => {
      state.user = action?.payload;
    },
    setIsLoading: (state, action) => {
      state.isLoading = action?.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setUserData, setUser, setIsLoading } = userSlice.actions;

export default userSlice.reducer;
